import feathersClient, { makeServicePlugin, BaseModel } from '../../feathers-client'

class WorkshopStepsFrameworks extends BaseModel {
  // Required for $FeathersVuex plugin to work after production transpile.

  static modelName = 'WorkshopStepsFrameworks'
  // Define default properties here
  static instanceDefaults () {
    return {
      frameworkId: null,
      workshopStepId: null,
    }
  }
}
const servicePath = 'workshop-steps-frameworks'
const servicePlugin = makeServicePlugin({
  Model: WorkshopStepsFrameworks,
  service: feathersClient.service(servicePath),
  servicePath,
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
})

export default servicePlugin
